




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CheckoutStore } from '@/store/checkoutstate';
import { Spinner } from 'spin.js';
import { AddOrUpdateCartItem } from '@/models/Cart/Cart';
import { GtmCartProduct, ImportToCart } from '@/models/Cart/Cart';
import { ApiService } from '@/services/ApiService';
import { CampaignModel } from '@/models/Cart/Checkout';
import { websiteText } from '@/mixins/websiteTexts';

@Component
export default class CartView extends Vue {
    get cart() {
        return CheckoutStore.cart;
    }
    public files: any;
    public excelRows: ImportToCart[];
    $refs!: {
        vue: Vue;
        fileupload: HTMLInputElement;
        vues: Vue[];
        elements: HTMLInputElement[];
    };
    protected spinner: Spinner;
    protected activeOrderRow: number = NaN;
    protected campaignCode: string = '';
    protected campaignCodeError: string = '';
    protected campaignCodeInfo: string = '';
    protected importedFileName: string = '';
    @Prop()
    private showBulkImportInCheckout!: boolean;
    private quantityChangedTriggered: boolean = false;
    private quantityDisplay: number = 0;
    constructor() {
        super();

        this.spinner = new Spinner({ scale: 0.5 });
        const currentCampaignCode = window.localStorage.getItem('campaignCode');
        this.campaignCode = currentCampaignCode == null ? '' : currentCampaignCode;
        this.files = new FormData();
        this.excelRows = [];
    }

    public activateOrderRow(index: number) {
        this.activeOrderRow = index;
        this.quantityDisplay = this.cart.orderRows[this.activeOrderRow].quantity;
    }

    public setActiveOrderRow(index: number) {
        if (this.activeOrderRow !== index) {
            this.activeOrderRow = index;
            this.quantityDisplay = this.cart.orderRows[this.activeOrderRow].quantity;
        }
    }

    public decreaseAmount2(index: number): void {
        this.setActiveOrderRow(index);
        if (this.quantityDisplay > 1) {
            this.decreaseAmount();
        } else {
            this.removeFromCart(index);
        }
    }

    public decreaseAmount(): void {
        this.quantityDisplay -= 1;
        if (this.quantityDisplay < 0) {
            this.quantityDisplay = 0;
        }
        if (!this.quantityChangedTriggered) {
            this.quantityChangedTriggered = true;
            const self = this;
            setTimeout(function() {
                const orderRow = self.cart.orderRows[self.activeOrderRow];
                const payload: AddOrUpdateCartItem = {
                    articleNumber: orderRow.articleNumber,
                    quantity: self.quantityDisplay,
                    rowSystemId: orderRow.rowSystemId,
                    comment: orderRow.comments,
                    type: ''
                };
                self.updateCart(payload);
                self.quantityChangedTriggered = false;
            }, 1500);
        }
    }

    public increaseAmount2(index: number): void {
        this.setActiveOrderRow(index);
        this.increaseAmount();
    }

    public increaseAmount(): void {
        this.quantityDisplay += 1;
        if (!this.quantityChangedTriggered) {
            this.quantityChangedTriggered = true;
            const self = this;
            setTimeout(function() {
                const orderRow = self.cart.orderRows[self.activeOrderRow];
                const payload: AddOrUpdateCartItem = {
                    articleNumber: orderRow.articleNumber,
                    quantity: self.quantityDisplay,
                    rowSystemId: orderRow.rowSystemId,
                    comment: orderRow.comments,
                    type: ''
                };
                self.updateCart(payload);
                self.quantityChangedTriggered = false;
            }, 1500);
        }
    }

    public removeFromCart(index: number): void {
        const orderRow = this.cart.orderRows[index];
        const payload: AddOrUpdateCartItem = {
            articleNumber: orderRow.articleNumber,
            quantity: 0,
            rowSystemId: orderRow.rowSystemId,
            comment: orderRow.comments,
            type: ''
        };
        this.updateCart(payload);
        this.activeOrderRow = NaN;
    }

    public isActiveOrderRow(index: number) {
        return this.activeOrderRow == index;
    }

    public setCampaignCode() {
        localStorage.setItem('campaignCode', this.campaignCode);

        const payload: CampaignModel = {
            campaignCode: this.campaignCode
        };

        ApiService.setCampaignCode(payload).then(response => {
            if (response.status == 200) {
                CheckoutStore.reloadState().then(() => {
                    /* nothing */
                });
                this.campaignCodeInfo = websiteText('checkout.campaigncodevalid');
                this.campaignCodeError = '';                
            } else if (response.status == 400) {
                const statusText =
                    typeof response.statusText === 'string' ? JSON.parse(response.statusText) : response.statusText;
                this.campaignCodeError = statusText.modelState.campaignCode[0];
                this.campaignCodeInfo = '';
                CheckoutStore.reloadState().then(() => {
                    /* nothing */
                });
            } else {
                this.campaignCodeError = '';
                this.campaignCodeInfo = '';
            }
        });
    }
    // public fileChange(fileList) {
    //     if (fileList[0].name.split('.').pop() != 'xls') {
    //         alert('Invalid file format');
    //         return false;
    //     }
    //     this.files = new FormData();
    //     this.files.append('file', fileList[0], fileList[0].name);
    //     this.importedFileName = fileList[0].name;

    //     const files = this.files;

    //     // this.spinner.spin(this.$el as HTMLElement);
    //     CheckoutStore.excelImportState(files).then(() => {
    //         this.excelRows = this.cart.itemsNotAdded;
    //         // this.spinner.stop();
    //         this.$refs.fileupload.value = '';
    //     });
    // }

    public getSampleCheckoutExcelFile(): void {
        this.spinner.spin(this.$el as HTMLElement);

        ApiService.getSampleCheckoutExcelFile().then(response => {
            if (response.status == 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'CartItems.xls');
                document.body.appendChild(link);
                link.click();

                this.spinner.stop();
            } else if (response.status == 400) {
                this.spinner.stop();
            } else {
                this.spinner.stop();
            }
        });
    }

    private updateCart(payload: AddOrUpdateCartItem): void {
        this.spinner.spin(this.$el as HTMLElement);
        CheckoutStore.updateState(payload).then(() => {
            this.spinner.stop();
        });
    }
}
